// extracted by css-extract-rspack-plugin
export default {"numericInput":"numericInput-MmHOHN","currencyAdornment":"currencyAdornment-ELf9mv","transferBlock":"transferBlock-GoIPYR","arrowIcon":"arrowIcon-KBNrZr"};